import { IconUserMarker } from './icons'

function UserMarker() {
  return <IconUserMarker className="w-10" />
}

export default UserMarker
